import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
export const GET_MORTGAGE_CLIENTS = "GET_MORTGAGE_CLIENTS";
export const GET_ACTIVITY_CLIENTS = "GET_ACTIVITY_CLIENTS";
export const GET_BIRTHDAY_CLIENTS = "GET_BIRTHDAY_CLIENTS";
export const GET_MORTGAGE_DAYS = "GET_MORTGAGE_DAYS";
export const GET_ACTIVITY_DAYS = "GET_ACTIVITY_DAYS";
export const GET_BIRTHDAY_DAYS = "GET_BIRTHDAY_DAYS";
export const GET_MORTGAGE_AGENT = "GET_MORTGAGE_AGENT";
export const GET_ACTIVITY_EXPIRED = "GET_ACTIVITY_EXPIRED";
export const GET_BIRTHDAY_AGENT = "GET_BIRTHDAY_AGENT";
export const GET_CLIENT_ACTIVITY = "GET_CLIENT_ACTIVITY";
export const GET_D2L_SUBMISSIONS = "GET_D2L_SUBMISSIONS";
export const GET_YOY_SUBMITTED = "GET_YOY_SUBMITTED";
export const GET_CLOSES_CURRENT = "GET_CLOSES_CURRENT";
export const GET_CLOSES_PREVIOUS = "GET_CLOSES_PREVIOUS";
export const GET_COMPLETED_APPS = "GET_COMPLETED_APPS";
export const GET_IN_PROGRESS_APPS = "GET_IN_PROGRESS_APPS";
export const GET_MORTGAGE_STATUS = "GET_MORTGAGE_STATUS";
const dashboard = {
  [GET_MORTGAGE_CLIENTS]: state => {
    return state.informationalCards.mortgages.clients;
  },
  [GET_ACTIVITY_CLIENTS]: state => {
    return state.informationalCards.activities.clients;
  },
  [GET_BIRTHDAY_CLIENTS]: state => {
    return state.informationalCards.birthdays.clients;
  },
  [GET_MORTGAGE_DAYS]: state => {
    return state.informationalCards.mortgages.numberOfDays;
  },
  [GET_ACTIVITY_DAYS]: state => {
    return state.informationalCards.activities.numberOfDays;
  },
  [GET_BIRTHDAY_DAYS]: state => {
    return state.informationalCards.birthdays.numberOfDays;
  },
  [GET_MORTGAGE_AGENT]: state => {
    return state.informationalCards.mortgages.agentUsername;
  },
  [GET_ACTIVITY_EXPIRED]: state => {
    return state.informationalCards.activities.expired;
  },
  [GET_MORTGAGE_STATUS]: state => {
    return state.informationalCards.mortgages.status;
  },
  [GET_BIRTHDAY_AGENT]: state => {
    return state.informationalCards.birthdays.agentUsername;
  },
  [GET_CLIENT_ACTIVITY]: state => {
    var _context;
    return _sortInstanceProperty(_context = _Object$values(state.clientActivity.byId)).call(_context, (a, b) => new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf());
  },
  [GET_D2L_SUBMISSIONS]: state => {
    return state.d2lSubmissions;
  },
  [GET_YOY_SUBMITTED]: state => {
    return state.charts.appsReceived;
  },
  [GET_CLOSES_CURRENT]: state => {
    return state.charts.closes.currentMonth;
  },
  [GET_CLOSES_PREVIOUS]: state => {
    return state.charts.closes.previousMonth;
  },
  [GET_COMPLETED_APPS]: state => {
    return state.charts.applications.completed;
  },
  [GET_IN_PROGRESS_APPS]: state => {
    return state.charts.applications.inProgress;
  }
};
export default dashboard;